<template>
    <div class="wrapper bg-primary d-flex align-items-center">
        <vue-headful
                title="Register - SIC Dashboard"
        />
        <div class="container-fluid align-items-center p-3">
            <div class="row justify-content-center">
                <div class="col-md-4">
                    <div class="card shadow border-0">
                        <div class="card-header border-0 text-center bg-transparent">
                            <div class="">
                                <img v-lazy="'img/brand/sic.png'" class="img-fluid">
                            </div>
                            <div class="text-center mt-2 pt-2">
                                <h3>Dashboard Registration</h3>
                            </div>
                        </div>
                        <div class="card-body">
                            <form role="form">
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-single-02"></i></span>
                                        </div>
                                        <input v-model="fullName" v-validate="'required|min:3|max:30'" name="fullName"
                                               data-vv-as="First Name" class="form-control" placeholder="Full Name"
                                               type="text">
                                    </div>
                                    <small v-if="errors.has('fullName')" class="text-danger">
                                        {{ errors.first('fullName') }}
                                    </small>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                                        </div>
                                        <input v-model="email" v-validate="'required|email'" name="email"
                                               data-vv-as="Email" class="form-control" placeholder="Email" type="email">
                                    </div>
                                    <small v-if="errors.has('email')" class="text-danger">
                                        {{ errors.first('email') }}
                                    </small>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-single-02"></i></span>
                                        </div>
                                        <input v-model="username" v-validate="'required|min:3|max:15'" name="username"
                                               data-vv-as="Username" class="form-control" placeholder="Username"
                                               type="text">
                                    </div>
                                    <small v-if="errors.has('username')" class="text-danger">
                                        {{ errors.first('username') }}
                                    </small>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="input-group input-group-alternative">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                                        </div>
                                        <input v-model="password" v-validate="'required|min:6|max:12'" name="password"
                                               data-vv-as="Password" class="form-control" placeholder="Password"
                                               type="password">
                                    </div>
                                    <small v-if="errors.has('password')" class="text-danger">
                                        {{ errors.first('password') }}
                                    </small>
                                </div>
                                <div class="text-center">
                                    <button @click="registerUser" type="button" class="btn btn-primary btn-block my-4">
                                        <i :class="{'loader': loading}"></i> {{registerButton}}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <router-link class="text-light text-primary" :to="{name: 'login'}">
                                <small>Dashboard Login</small>
                            </router-link>
                        </div>
                        <div class="col-6 text-right">
                            <router-link class="text-light text-primary" :to="{name: 'forgot-password'}">
                                <small>Forgot Password ?</small>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import _ from "lodash";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      loading: false,
      registerButton: "Register",
      fullName: "",
      email: "",
      username: "",
      password: ""
    };
  },
  methods: {
    registerUser() {
      this.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            return;
          }

          this.registerButton = "";
          this.loading = true;
          axios({
            method: "post",
            url: "admin/new",
            data: {
              access_token: "",
              full_name: this.fullName,
              email: this.email,
              username: this.username,
              password: this.password
            },
            headers: {
              "Content-Type": "application/json"
            }
          })
            .then(
              result => {
                this.$swal(
                  "User Registration Successful",
                  "You may now login to the dashboard",
                  "success"
                );
                console.log(result);
                this.$validator.reset();
                this.clearFields();
                this.loading = false;
                this.registerButton = "Register";
              },
              error => {
                this.loading = false;
                this.registerButton = "Register";
                this.$swal(
                  "Error",
                  "There was an error. Please try again",
                  "error"
                );
                let errors = error.response.data.error;
                for (let error in errors) {
                  this.$noty.error("Error: " + _.startCase(errors[error][0]));
                }
              }
            )
            .catch(e => {
              this.loading = false;
              this.registerButton = "Register";
              console.log("catch " + e.response);
            });
        })
        .catch(e => {
          console.log(e.response);
        });
    },
    clearFields() {
      this.fullName = "";
      this.email = "";
      this.username = "";
      this.password = "";
    }
  },
  computed: {
    isComplete() {
      return this.fullName && this.email && this.username && this.password;
    }
  },
  components: {
    "vue-headful": vueHeadful
  }
};
</script>
<style scoped>
.wrapper {
  height: 100vh !important;
  width: 100vw !important;
}
</style>
